"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceBreakpointsToObject = void 0;

var _theme = require("../../../theme");

var reduceBreakpointsToObject = function reduceBreakpointsToObject(breakpointCallback) {
  return Object.keys(_theme.Mixin.Screen).reduce(function (destinationObject, breakpoint) {
    return Object.assign(destinationObject, breakpointCallback(breakpoint));
  }, {});
};

exports.reduceBreakpointsToObject = reduceBreakpointsToObject;